import { useState, useRef } from "react";
import { Send, Loader2, Sparkles } from "lucide-react";
import { MessageList } from "@/components/AIPanel";
import { useChatStream } from "@/hooks/useChatStream";
import { AI_CHIPS } from "@/data/knowledge";

export const AskAI = () => {
  const [input, setInput] = useState("");
  const weightRef = useRef("sub250");
  const { messages, streaming, streamChat } = useChatStream(weightRef);

  const send = (text) => {
    if (!text.trim() || streaming) return;
    setInput("");
    streamChat(text.trim());
  };

  return (
    <div data-testid="home-ask-ai" className="ask-ai-pop bg-black/70 backdrop-blur-2xl border-2 border-[#2ec4b6]/70 rounded-3xl overflow-hidden flex flex-col" style={{ minHeight: 420, maxHeight: 560 }}>
      <div className="flex items-center gap-2.5 px-5 py-4 border-b border-[#2ec4b6]/30 bg-[#2ec4b6]/10">
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#2ec4b6] opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-[#2ec4b6]"></span>
        </span>
        <Sparkles size={18} className="text-[#2ec4b6]" />
        <p className="font-heading font-bold text-lg text-white">Ask <span className="text-[#2ec4b6]">Maverick</span> anything</p>
        <span className="ml-auto text-[10px] uppercase tracking-[0.2em] text-[#2ec4b6] font-bold">Live AI · CAP 722</span>
      </div>
      <MessageList
        messages={messages}
        streaming={streaming}
        emptyTitle="Your personal drone expert"
        emptyHint="Ask absolutely anything — UK law, registration, which drone to buy, camera settings, FPV rules, careers. Try a suggestion below."
      />
      <div className="p-4 border-t border-white/10 space-y-3">
        {messages.length === 0 && (
          <div className="flex flex-wrap gap-2">
            {AI_CHIPS.map((c) => (
              <button
                key={c}
                data-testid="home-ai-chip"
                onClick={() => send(c)}
                className="text-xs px-3 py-1.5 rounded-full border border-white/15 text-zinc-200 hover:border-[#2ec4b6]/50 hover:text-[#2ec4b6] transition-colors"
              >
                {c}
              </button>
            ))}
          </div>
        )}
        <div className="flex items-center gap-2">
          <input
            data-testid="home-ai-input"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && send(input)}
            placeholder="Any drone question — law, gear, technique…"
            aria-label="Ask the drone AI"
            className="flex-1 bg-white/5 border border-white/10 rounded-full px-4 py-3 text-sm outline-none placeholder:text-zinc-400 text-zinc-100 focus:border-[#2ec4b6]/50 transition-colors"
          />
          <button
            data-testid="home-ai-send"
            disabled={streaming || !input.trim()}
            onClick={() => send(input)}
            className="shrink-0 w-11 h-11 rounded-full bg-[#2ec4b6] text-black flex items-center justify-center disabled:opacity-30 hover:bg-[#3dd8ca] transition-colors"
          >
            {streaming ? <Loader2 size={16} className="animate-spin" /> : <Send size={15} />}
          </button>
        </div>
      </div>
    </div>
  );
};
